module.exports = __webpack_public_path__ + "static/ATTN-PROFILE-WHITE-ON-ORANGE.79b058dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ATTN-PROFILE-WHITE-ON-ORANGE.jpg
// module id = 1182
// module chunks = 114276838955818